<div
  [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme"
  (mouseover)="sidebarHover()"
  (mouseout)="sidebarHover()"
>
  <div class="app-header__logo">
    <div class="logo-src" routerLink=""></div>
    <div class="header__pane ms-auto">
      <button
        type="button"
        class="hamburger close-sidebar-btn hamburger--elastic"
        [ngClass]="{ 'is-active': globals.toggleSidebar }"
        (click)="toggleSidebar()"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>
  <div class="app-sidebar-content">
    <div class="app-sidebar-scroll">
      <perfect-scrollbar [autoPropagation]="true">
        <div class="v-sidebar-menu vsm-default">
          <div class="vsm-list">
            <ngb-accordion
              [destroyOnHide]="false"
              [closeOthers]="true"
              [activeIds]="extraParameter"
            >
              <ngb-panel>
                <ng-template ngbPanelHeader>
                  <div class="vsm-header">Main Navigation</div>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="dashboardsMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-rocket"></i>
                    <span class="vsm-title"
                      >Dashboards <i class="fa-brands fa-angular"></i
                    ></span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLink=""
                          routerLinkActive="active-item"
                          [routerLinkActiveOptions]="{ exact: true }"
                          class="vsm-link"
                          ><span class="vsm-title">Analytics</span></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
            

              <ngb-panel id="notifications">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-users"></i>
                    <span class="vsm-title">Notifications</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="send-notification"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="pe-7s-users"> </i> Send Notifications</span
                          ></a
                        >
                      </div>
                         <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="view-notification-history"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-wallet"></i> Notification History</span
                          ></a
                        >
                      </div>                      
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
            

              <ngb-panel id="users">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-users"></i>
                    <span class="vsm-title">Users</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="users"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="pe-7s-users"> </i> All Users</span
                          ></a
                        >
                      </div>
                         <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user-withdrawal-requests"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-wallet"></i> User Withdrwal
                            Request</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user/deposite/transaction"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-inr"></i> User Deposites</span
                          ></a
                        >
                      </div>
                      
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="drivers">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon fa fa-male"></i>

                    <span class="vsm-title">Drivers</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="online-drivers"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-truck"></i> Online Drivers</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="addDrivers"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-plus"></i> Add Driver</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="drivers"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-male"></i> Driver</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driverWithdrawalRequest"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-wallet"></i> Driver Withdrwal
                            Request</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driver/deposite/transaction"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-inr"></i> Driver Deposites</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="vehicle">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-car"></i>
                    <span class="vsm-title">Vehicles</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="addVehicle"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-plus"></i> Add Vehicles</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="vehicle"
                          class="vsm-link"
                          ><span class="vsm-title">All Vehicles</span></a
                        >
                      </div>

                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="vacant-vehicles"
                          class="vsm-link"
                          ><span class="vsm-title">4+ ton vehicles</span></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="truck-tyres"
                          class="vsm-link"
                          ><span class="vsm-title">Truck Tyres</span></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="vehicleBooking"
                          class="vsm-link"
                          ><span class="vsm-title">Vehicles Booking</span></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="package">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Packages</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="addPackage"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-plus"></i> Add Packages</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="package"
                          class="vsm-link"
                          ><span class="vsm-title">All Packages</span></a
                        >
                      </div>
                      <!-- <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="trackAllPackages" class="vsm-link"><span
                          class="vsm-title">Track All Packages</span></a>
                      </div> -->
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

                    <ngb-panel id="Enterprise">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Enterprise</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterprise-trips"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-route"></i>Trips</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterprise-subscription-plans"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-star"></i>User Subscription</span
                          ></a
                        >
                      </div>

                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterprises"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-star"></i>Enterprises</span
                          ></a
                        >
                      </div>

                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user-enterprise-requests"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="pe-7s-users"> </i>Enterprise Requests</span
                          ></a
                        >
                      </div>
                       <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterprise-employee-requests"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="pe-7s-users"> </i>Employee Requests</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterprise-branch-requests"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="pe-7s-users"> </i>Branch Requests</span
                          ></a
                        >
                      </div>
                      <!-- <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="trackAllPackages" class="vsm-link"><span
                          class="vsm-title">Track All Packages</span></a>
                      </div> -->
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="post-adds">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Vacant Vehicle</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driver-post-adds"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-truck-loading"></i> Driver
                            Posts</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user-post-adds"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-trailer"></i> User Posts</span
                          ></a
                        >
                      </div>
                       <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driver-load-alerts"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-bell"></i> Driver Load Alerts</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user-load-alerts"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-bell"></i> User Vehicle Alerts</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="user-vacant-vehicle-search"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-search-location"></i> User Vehicle Search</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driver-load-search"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-search"></i> Driver Load Search</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

               <ngb-panel id="packersMovers">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Packers Movers</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="website-packers-movers-users"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-plus"></i> Users Requirements</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="website-packers-movers-requests"
                          class="vsm-link"
                          ><span class="vsm-title">Website PM Requests</span></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="packerMoverRequest"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="pe-7s-call"></i>Android PM Requests</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

                <ngb-panel id="Warehouse">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-box2"></i>
                    <span class="vsm-title">Warehouse</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="warehouse-requirements"
                          class="vsm-link"
                          ><span class="vsm-title">warehouse Requirements</span></a
                        >
                      </div>
                      <!-- <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="trackAllPackages" class="vsm-link"><span
                          class="vsm-title">Track All Packages</span></a>
                      </div> -->
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

             <ngb-panel id="support">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Support </span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="support"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-life-ring"></i> Support
                            Requests</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>


              <ngb-panel id="subscription">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Driver Subscription</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="view-subscription-list"
                          class="vsm-link"
                          ><span class="vsm-title"
                            >Subscription Plans</span
                          ></a
                        >
                      </div>
                      <!-- <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="trackAllPackages" class="vsm-link"><span
                          class="vsm-title">Track All Packages</span></a>
                      </div> -->
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="cities">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon fa fa-map-marker"></i>
                    <span class="vsm-title">Cities</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="city"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-map-marker" aria-hidden="true"></i>
                            All Cities
                          </span></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="vendor">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon fa fa-user-o"></i>
                    <span class="vsm-title">Vendor</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="upload"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i
                              class="fa fa-file-excel-o"
                              aria-hidden="true"
                            ></i>
                            Upload CSV
                          </span></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="admin">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Admin</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="addAdmin"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-plus"></i> Add Admin</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="admin"
                          class="vsm-link"
                          ><span class="vsm-title">All Admin</span></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="requests">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-call"></i>
                    <span class="vsm-title">Requests</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="pickDropRequest"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="pe-7s-call"></i> Goods Courier
                            Requests</span
                          ></a
                        >
                      </div>
                      
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="driverPartnerRequest"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="pe-7s-call"></i> Drivers Requests</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="enterpriseRequest"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="pe-7s-call"></i> Enterprise Requests</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="settings">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-settings"></i>
                    <span class="vsm-title">Settings</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="addConfiguration"
                          class="vsm-link"
                          ><span class="vsm-title"
                            ><i class="fa fa-plus"></i> Add Configuraion</span
                          ></a
                        >
                      </div>
                      <div class="vsm-item">
                        <a
                          routerLinkActive="active-item"
                          routerLink="configuration"
                          class="vsm-link"
                          ><span class="vsm-title">
                            <i class="fa fa-eye"></i> View & Update
                            Config.</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>

              <!-- <ngb-panel id="pagesMenu1">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-browser"></i>
                    <span class="vsm-title">Pages</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="payments" class="vsm-link"><span
                          class="vsm-title"><i class="fa fa-university" aria-hidden="true"></i>
                           Payments</span></a>
                      </div>
                  
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="business" class="vsm-link"><span
                          class="vsm-title">Business</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="setting" class="vsm-link"><span
                          class="vsm-title"><i class="fa fa-wrench" aria-hidden="true"></i>
                          Setting</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="pages/login-boxed" class="vsm-link"><span
                          class="vsm-title">Login Boxed</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="pages/register-boxed" class="vsm-link"><span
                          class="vsm-title">Register Boxed</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="pages/forgot-password-boxed"
                           class="vsm-link"><span class="vsm-title">Forgot Password Boxed</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel> -->

              <!-- <ngb-panel>
                <ng-template ngbPanelHeader>
                  <div class="vsm-header">Bootstrap Components</div>
                </ng-template>
              </ngb-panel> -->

              <!-- <ngb-panel id="elementsMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-diamond"></i>
                    <span class="vsm-title">Elements</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/buttons-standard"
                           class="vsm-link"> <span
                          class="vsm-title">Standard Buttons</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/dropdowns" class="vsm-link"> <span
                          class="vsm-title">Dropdowns</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/icons" class="vsm-link"><span
                          class="vsm-title">Icons</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/cards" class="vsm-link"><span
                          class="vsm-title">Cards</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/list-group" class="vsm-link"> <span
                          class="vsm-title">List Groups</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="elements/timeline" class="vsm-link"> <span
                          class="vsm-title">Timeline</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel> -->

              <!-- <ngb-panel id="componentsMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-car"></i>
                    <span class="vsm-title">Components</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                     
                     
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/accordions" class="vsm-link"> <span
                          class="vsm-title">Accordions</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/modals" class="vsm-link"> <span
                          class="vsm-title">Modals</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/progress-bar" class="vsm-link"> <span
                          class="vsm-title">Progress Bar</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/tooltips-popovers"
                           class="vsm-link"> <span
                          class="vsm-title">Tooltips &amp; Popovers</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/carousel" class="vsm-link"> <span
                          class="vsm-title">Carousel</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="components/pagination" class="vsm-link"> <span
                          class="vsm-title">Pagination</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="formElementsMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-helm"></i>
                    <span class="vsm-title">Form Elements</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="forms/controls" class="vsm-link"><span
                          class="vsm-title">Controls</span></a>
                      </div>
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="forms/layouts" class="vsm-link"><span
                          class="vsm-title">Layouts</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="tablesMenu">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-safe"></i>
                    <span class="vsm-title">Tables</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="tables/bootstrap" class="vsm-link"> <span
                          class="vsm-title">Bootstrap 5 Tables</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel>
              <ngb-panel>
                <ng-template ngbPanelHeader>
                  <div class="vsm-header">Dashboard Boxes</div>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="pagesMenu3">
                <ng-template ngbPanelHeader>
                  <button ngbPanelToggle class="vsm-link">
                    <i class="vsm-icon pe-7s-graph2"></i>
                    <span class="vsm-title">Chart Boxes</span>
                    <i class="vsm-arrow"></i>
                  </button>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div class="vsm-dropdown">
                    <div class="vsm-list">
                      <div class="vsm-item">
                        <a routerLinkActive="active-item" routerLink="widgets/chart-boxes-3" class="vsm-link">
                          <span class="vsm-title">Variation 3</span></a>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ngb-panel> -->
            </ngb-accordion>
            <!-- <div class="vsm-header">Charts</div>
            <div class="vsm-item">
              <a routerLink="charts/chartjs" routerLinkActive="active-item" class="vsm-link">
                <i class="vsm-icon pe-7s-graph2"></i>
                <span class="vsm-title">ChartJS</span>
              </a>
            </div> -->
          </div>
        </div>
      </perfect-scrollbar>
    </div>
  </div>
</div>
